import React from 'react';

import { StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

export function OtherAvailableOptionsHeader() {
  return (
    <View style={styles.container} testID="other-available-options-header">
      <View style={styles.line} />
      <Typography variant="copyOne" color={primitive.$bbqBrown} style={styles.label}>
        {t('otherAvailableOptions')}
      </Typography>
      <View style={styles.line} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: spacing.$3,
    marginBottom: spacing.$4,
    marginTop: spacing.$2,
    paddingHorizontal: spacing.$4,
    width: '100%',
  },
  label: {
    flexShrink: 1,
    textAlign: 'center',
  },
  line: {
    backgroundColor: primitive.$bbqBrown,
    flex: 1,
    height: StyleSheet.hairlineWidth,
  },
});
